import { Route, Routes } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { HomePage } from "@/pages/HomePage";
import { PlaceholderPage } from "@/pages/PlaceholderPage";
import { CandidatosPage } from "@/pages/CandidatosPage";
import { CandidatoFichaPage } from "@/pages/CandidatoFichaPage";
import { ReniecPage, OnpePage, JnePage } from "@/pages/InstitucionesPages";
import { CasoGalagaPage } from "@/pages/CasoGalagaPage";
import { Mesas900KPage } from "@/pages/Mesas900KPage";
import { CrecimientoPadronPage } from "@/pages/CrecimientoPadronPage";
import { FuentesNoVerificadasPage } from "@/pages/FuentesNoVerificadasPage";
import { Erm2026IndexPage } from "@/pages/Erm2026IndexPage";
import { Erm2026JeePage } from "@/pages/Erm2026JeePage";
import { DelPalacioAlConcejoPage } from "@/pages/DelPalacioAlConcejoPage";
import { Eg2026IndexPage, Eg2026E1Page, Eg2026E2Page } from "@/pages/Eg2026Pages";

const PLACEHOLDERS: Array<[string, string]> = [
  ["/expediente-electoral", "Expediente Electoral"],
  ["/trazabilidad", "Trazabilidad"],
  ["/instituciones", "Instituciones"],
  ["/onpe-online", "ONPE Online"],
  ["/jne-online", "JNE Online"],
  ["/manipulacion-electoral", "Manipulación electoral"],
  ["/analisis", "Análisis institucional"],
  ["/historia-electoral", "Historia electoral del Perú"],
  ["/laboratorio", "Laboratorio electoral"],
  ["/registro", "Registro ciudadano"],
];

export default function App() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/candidatos" element={<CandidatosPage />} />
          <Route path="/candidatos/:slug" element={<CandidatoFichaPage />} />
          <Route path="/reniec" element={<ReniecPage />} />
          <Route path="/onpe" element={<OnpePage />} />
          <Route path="/jne" element={<JnePage />} />
          <Route path="/caso-galaga" element={<CasoGalagaPage />} />
          <Route path="/mesas-900k" element={<Mesas900KPage />} />
          <Route path="/laboratorio/crecimiento-padron" element={<CrecimientoPadronPage />} />
          <Route path="/fuentes/noverificadas" element={<FuentesNoVerificadasPage />} />
          <Route path="/fuentes" element={<FuentesNoVerificadasPage />} />
          <Route path="/erm2026" element={<Erm2026IndexPage />} />
          <Route path="/erm2026/jee" element={<Erm2026JeePage />} />
          <Route path="/erm2026/del-palacio-al-concejo" element={<DelPalacioAlConcejoPage />} />
          <Route path="/eg2026" element={<Eg2026IndexPage />} />
          <Route path="/eg2026/e1" element={<Eg2026E1Page />} />
          <Route path="/eg2026/e2" element={<Eg2026E2Page />} />
          {PLACEHOLDERS.map(([path, titulo]) => (
            <Route key={path} path={path} element={<PlaceholderPage titulo={titulo} />} />
          ))}
          <Route path="*" element={<PlaceholderPage titulo="Página no encontrada" />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}
